function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { clone } from 'ramda';
import store from '../reducers/storeRegistration';
import serverNativeBehaviorEvaluator from './serverNativeBehaviorEvaluator';
import { getCachedFormContent, setCachedFormContent } from './lib/formContentCache';
const liveContentForUUID = uuid => {
  var _state$form, _state$formModal;
  if (!uuid) {
    return undefined;
  }
  const state = store.getState();
  const formActive = (_state$form = state.form) === null || _state$form === void 0 ? void 0 : _state$form.active;
  if ((formActive === null || formActive === void 0 ? void 0 : formActive.id) === uuid && formActive.content) {
    return clone(_objectSpread(_objectSpread({}, formActive.content), {}, {
      id: formActive.id || uuid
    }));
  }
  const modalActive = (_state$formModal = state.formModal) === null || _state$formModal === void 0 ? void 0 : _state$formModal.active;
  if ((modalActive === null || modalActive === void 0 ? void 0 : modalActive.id) === uuid && modalActive.content) {
    return clone(_objectSpread(_objectSpread({}, modalActive.content), {}, {
      id: modalActive.id || uuid
    }));
  }
  return undefined;
};

/**
 * Resolve form content: live (open editor) → shared cache → server store.
 * Seeds the shared cache on store load. Does not use editor scratch formCache.
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  if (!(source !== null && source !== void 0 && source.uuid)) {
    return serverNativeBehaviorEvaluator.evaluate(entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator);
  }
  const {
    uuid
  } = source;
  const live = liveContentForUUID(uuid);
  if (live !== undefined) {
    return live;
  }
  const cached = getCachedFormContent(uuid);
  if (cached !== undefined && cached.overview !== true) {
    return cached;
  }
  const fromStore = await serverNativeBehaviorEvaluator.evaluate(entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator);
  if (fromStore !== undefined && fromStore !== null && fromStore.overview !== true) {
    setCachedFormContent(uuid, fromStore);
  }
  return fromStore;
};
export default {
  evaluate
};